// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 2,
          '&.Mui-selected': {
            color: theme.vars.palette.primary.main,
            backgroundColor: 'rgba(13,148,136,0.08)',
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.primary.main
            },
            '&:hover': {
              backgroundColor: 'rgba(13,148,136,0.12)',
            }
          },
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.03)',
          }
        }
      }
    }
  };
}
